const BASE = 'LBConnect-';

export const APP_CONST = {
  LOCAL_STORAGE: {
    ROLE: `${BASE}profile`,
    AUTH_TOKEN: `${BASE}auth`,
    REFRESH_TOKEN: `${BASE}refresh`,
    LOCALE: `${BASE}locale`,
    IS_FIRST_LOGIN: `${BASE}first-login`
  }
};
